import { createReducer } from '../utils/helpers';
import { ActionTypes } from '../utils/constants';

export const versionState = {
  data: [],
  isLoading: false,
};

export default {
  version: createReducer(versionState, {
    [ActionTypes.FETCH_VERSION_REQUEST](state) {
        return {
            ...state,
            isLoading: true,
        };
    },
    [ActionTypes.FETCH_VERSION_SUCCESS](state, action) {
        const { data } = action.payload;
        if (!data) {
            return {
                ...state,
                isLoading: false,
            };
        }
        return {
            ...state,
            data: [
                ...state.data,
                data
            ],
            isLoading: false,
        };
    },
    [ActionTypes.FETCH_VERSION_FAILURE](state) {
        return {
            ...state,
            isLoading: false,
        };
    },
  }),
};
